module.exports = __webpack_public_path__ + "assets/img/card-back.324c8285.png";